import { Component, Input } from '@angular/core';

/**
 * Component to display the user menu settings
 *
 * @export
 * @class UserProfileComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() version: string;
  constructor() {}
}
